<template>
  <div class="container-fluid bg-light">
    <div class="row justify-content-center align-items-center min-vh-100">
      <div class="col">
        <div class="card shadow">
          <img src="@/assets/images/logo-wide-black.png" class="card-img-top pt-4 px-4" />
          <div class="card-body">
            <h4 class="card-title text-center">Authenticating ...</h4>
            <p v-if="!alertMessage" class="text-center"><fa icon="circle-notch" size="lg" spin /></p>
            <div v-if="alertMessage" class="alert alert-danger" role="alert">
              <p class="text-center mb-0">
                {{ alertMessage }}
              </p>
            </div>
            <ErrorSummary :error="error" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ErrorSummary from "@/components/ErrorSummary.vue";

export default {
  components: {
    ErrorSummary,
  },
  data() {
    return {
      alertMessage: null,
      error: null,
    };
  },
  computed: {
    ...mapGetters("signin", ["redirect"]),
    ...mapGetters("user", ["user"]),
  },
  created() {
    if (this.user) {
      this.$router.push(this.redirect);
      this.$store.commit("signin/setRedirect", "/");
      return;
    }

    this.process();
  },
  methods: {
    ...mapActions("workos", {
      workosCompleteSignIn: "completeSignIn",
    }),
    async process() {
      await new Promise(r => setTimeout(r, 1000));

      let res = await this.workosCompleteSignIn();

      if (res.success) {
        this.$router.push(this.redirect);
        this.$store.commit("signin/setRedirect", "/");
      } else {
        this.alertMessage = res.error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  width: 400px;
  margin: 0 auto;
}
</style>
